import type { BuildValidator } from "./buildValidator";
const GUARD_KEY = "build-validator::mismatch-reload";
export type BuildValidationResult = Awaited<ReturnType<BuildValidator["validateBuildConsistency"]>>;
export async function resolveBuildMismatch(validation: BuildValidationResult) {
  // Skip automatic reload in dev mode - build SHA changes frequently during development
  if (import.meta.env.VITE_ENV_LABEL === 'DEV' || import.meta.env.DEV) {
    console.log('[BuildValidator] Skipping auto-reload in dev mode');
    return;
  }
  
  if (validation.isValid || typeof window === "undefined") return;
  const guardId = `${GUARD_KEY}:${validation.serverSha ?? "unknown"}:${validation.clientSha ?? "unknown"}:${validation.swSha ?? "unknown"}`; let shouldReload = true;
  try {
    const store = window.sessionStorage; if (store.getItem(guardId)) shouldReload = false; else store.setItem(guardId, Date.now().toString());
  } catch (error) { console.warn("[BuildValidator] Failed to persist mismatch guard:", error); }
  if (!shouldReload || (window as any).__buildValidatorReloading) return; (window as any).__buildValidatorReloading = true;
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.getRegistration(); await registration?.update(); registration?.waiting?.postMessage({ type: "SKIP_WAITING" });
    } catch (error) { console.warn("[BuildValidator] Failed to update service worker:", error); }
  }
  if ("caches" in window) {
    try {
      const cacheNames = await caches.keys(); await Promise.all(cacheNames.map((name) => caches.delete(name)));
    } catch (error) { console.warn("[BuildValidator] Failed to clear caches:", error); }
  }
  window.setTimeout(() => window.location.reload(), 50);
}
